import $api from '@/api/index'
import Vue from 'vue'
// 基本模块
const baseModule = {
  state: {
    typeList: [],
    allUserList: [],
    userNameById: {}
  },
  mutations: {
    setPGType: (state, data) => {
      state.typeList = data
    },
    setAllUser: (state, data) => {
      state.allUserList = data
      data.forEach(o => {
        Vue.set(state.userNameById, o.Id, o.Name)
      })
    }
  },
  actions: {
    getPGTypeList: ({commit}) => {
      $api.getPGTypeList(res => {
        commit('setPGType', res)
      })
    },
    getAllUser: ({commit}) => {
      $api.getUserList({}, res => {
        commit('setAllUser', res.list)
      })
    }
  }
}

export default baseModule



// WEBPACK FOOTER //
// ./src/store/pg.js